import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  createTerminalUpdate,
  deleteTerminalUpdate,
  fetchTerminalUpdates,
  updateTerminalUpdate,
} from "../../apis/terminalUpdates";

import type { TerminalUpdate } from "../../utils/types/terminalUpdates";

export const fetchTerminalUpdatesList = createAsyncThunk(
  "terminalUpdates/fetchList",
  async (portCallingsId: string | undefined, { rejectWithValue }) => {
    try {
      return await fetchTerminalUpdates(portCallingsId);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const addTerminalUpdate = createAsyncThunk(
  "terminalUpdates/add",
  async (
    { data }: { data: Partial<TerminalUpdate> },
    { rejectWithValue }
  ) => {
    try {
      return await createTerminalUpdate(data);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const editTerminalUpdate = createAsyncThunk(
  "terminalUpdates/edit",
  async (
    { id, data }: { id: string; data: Partial<TerminalUpdate> },
    { rejectWithValue }
  ) => {
    try {
      return await updateTerminalUpdate(id, data);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const removeTerminalUpdate = createAsyncThunk(
  "terminalUpdates/remove",
  async ({ id }: { id: string }, { rejectWithValue }) => {
    try {
      return await deleteTerminalUpdate(id);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);
